import {clear_token,get_token} from "@/router";
export default {
  name: 'InactivityModal',
  data() {
    return ({
      showModal: false,
      token_exists:false,
      timeoutId: null,
      inactivityTime:  30 * 60 * 1000, // 1 minute
      events: ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'],
    });
  },
  methods: {
    startTimer() {
      this.clearTimer();
      this.timeoutId = setTimeout(() => {
        this.showModal = true;
      }, this.inactivityTime);
    },
    clearTimer() {
      if (this.timeoutId) clearTimeout(this.timeoutId);
    },
    stayLoggedIn() {
      this.showModal = false;
      this.startTimer(); // reset timer
    },
    logout() {
      this.showModal = false;
      this.clearTimer();
      clear_token();
      window.location.href = `/`;
    },
    handleActivity() {
      if (!this.showModal) {
        this.startTimer();
      }
    },
  },
  mounted() {
    this.token_exists=get_token();
    this.startTimer();
    this.events.forEach((event) => {
      window.addEventListener(event, this.handleActivity);
    });
  },
  unmounted() {
    this.clearTimer();
    this.events.forEach((event) => {
      window.removeEventListener(event, this.handleActivity);
    });
  },
};